import React from "react"
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Trans} from "@lingui/macro";

interface SbDialogProps {
    onClose: () => void
    width:  'xs' | 'sm' | 'md' | 'lg' | 'xl'
    titleText: string
    height?: string
    contentText?: string
    children?: any
    saveButton?: boolean
    confirmButton?: boolean
    confirmAndSaveButton?: boolean
    deleteButton?: boolean
    cancelButton?: boolean
    closeButton?: boolean
    onSave?: () => void
    onConfirm?: () => void
    onDelete?: () => void
}

interface SbDialogState {

}

export class SbDialog extends React.Component<SbDialogProps, SbDialogState>
{
    render () {
        return (
            <Dialog open={true} onClose={this.props.onClose} maxWidth={this.props.width} fullWidth>
                <DialogTitle>
                    {this.props.titleText}
                </DialogTitle>
                {
                    this.props.height ?
                        <DialogContent sx={{height: this.props.height}}>
                            {this.props.contentText}
                            {this.props.children}
                        </DialogContent>
                            :
                        <DialogContent>
                            {this.props.contentText}
                            {this.props.children}
                        </DialogContent>
                }

                <DialogActions>
                    {
                        this.props.cancelButton &&
                        <Button onClick={this.props.onClose}
                                variant={"contained"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                            <Trans id={"sb-dialog.cancel"}>
                                Annulla
                            </Trans>
                        </Button>
                    }
                    {
                        this.props.closeButton &&
                        <Button onClick={this.props.onClose}
                                variant={"contained"}
                                color="neutral"
                                sx={{
                                    textTransform: "none",
                                    mr: 1,
                                    width: 100
                                }}
                                disableElevation>
                            <Trans id={"sb-dialog.close"}>
                                Chiudi
                            </Trans>
                        </Button>
                    }
                    {
                        this.props.confirmButton &&
                        <Button onClick={this.props.onConfirm}
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 100
                                }}
                        >
                            <Trans id={"sb-dialog.confirm"}>
                                Conferma
                            </Trans>
                        </Button>
                    }
                    {
                        this.props.confirmAndSaveButton &&
                        <Button onClick={this.props.onConfirm}
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 200
                                }}
                        >
                            <Trans id={"sb-dialog.confirm-and-save"}>
                                Conferma e salva
                            </Trans>
                        </Button>
                    }
                    {
                        this.props.deleteButton &&
                        <Button onClick={() => {}}
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 100
                                }}
                        >
                            <Trans id={"sb-dialog.delete"}>
                                Elimina
                            </Trans>
                        </Button>
                    }
                    {
                        this.props.saveButton &&
                        <Button onClick={this.props.onSave}
                                variant="contained"
                                sx={{
                                    backgroundColor: 'secondary.main',
                                    color: 'white',
                                    mr: 1,
                                    textTransform: "none",
                                    width: 100
                                }}
                        >
                            <Trans id={"sb-dialog.save"}>
                                Salva
                            </Trans>
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}
